module.exports = __webpack_public_path__ + "static/media/marca_inicio.56a75066.png";